import React from 'react';

const FormInput = ({tag,type,name,placeholder,classes, onSubmit, onKeyDownCapture, onClick, onChange}) => {
    return (
        <div className="single-input-item">
            <label>
                {(()=>{
                    if(tag === 'input'){
                        return <input type={type} name={name} placeholder={placeholder} className={classes} onChange={onChange} onKeyDownCapture={onKeyDownCapture} onSubmit={onSubmit} />
                    }else if(tag === 'textarea'){
                        return  <textarea name={name} cols="30" rows="7" placeholder={placeholder} className={classes} onChange={onChange} onKeyDownCapture={onKeyDownCapture} onSubmit={onSubmit} required/>
                    }else if(tag === 'button'){
                        return <button onSubmit={onSubmit} onClick={onClick} style={{backgroundColor:'#288d36',transition:'0.2s',transitionDuration:'0.2s', transitionProperty:'all', transitionTimingFunction:'ease', transitionDelay:'0s'}}  className={`btn btn-brand`}>Enviar</button>
                    }else if(tag === 'checkbox'){
                        return <input   type={type} name={name} placeholder={placeholder} className={classes} onChange={onChange} onKeyDownCapture={onKeyDownCapture} onSubmit={onSubmit}/>
                    }
                })()}
            </label>
        </div>
    );
};

export default FormInput;